import Navbar from "@/components/landing/Navbar";
import Footer from "@/components/landing/Footer";

const DeleteAccount = () => {
  const steps = [
    "Ouvrez l'application CoachOS sur votre appareil.",
    "Accédez à votre Profil (onglet en bas à droite).",
    "Appuyez sur Paramètres.",
    "Sélectionnez Supprimer mon compte.",
    "Confirmez la suppression.",
  ];

  const deletedData = [
    "Compte utilisateur et informations de profil",
    "Historique des séances d'entraînement",
    "Programmes et données de nutrition",
    "Photos de progression",
    "Messages et échanges avec le coach",
    "Notes et check-ins",
  ];

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container max-w-3xl py-24">
        <h1 className="text-3xl font-bold text-foreground mb-4">Suppression de compte</h1>
        <p className="text-muted-foreground leading-relaxed mb-8">
          Vous pouvez demander la suppression de votre compte CoachOS et de toutes les données associées à tout moment.
        </p>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-3">Procédure dans l'application</h2>
          <ol className="space-y-3">
            {steps.map((step, i) => (
              <li key={i} className="flex items-start gap-3 text-muted-foreground leading-relaxed">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-accent/10 text-accent text-xs font-bold flex items-center justify-center mt-0.5">
                  {i + 1}
                </span>
                <span>{step}</span>
              </li>
            ))}
          </ol>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold text-foreground mb-3">Données supprimées</h2>
          <ul className="space-y-2">
            {deletedData.map((item) => (
              <li key={item} className="flex items-center gap-2 text-muted-foreground leading-relaxed">
                <span className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
          <p className="text-sm text-muted-foreground mt-4">
            La suppression est définitive et sera effective sous <strong className="text-foreground">30 jours</strong> suivant votre demande.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-foreground mb-3">Demande par email</h2>
          <p className="text-muted-foreground leading-relaxed">
            Si vous ne pouvez pas accéder à l'application, envoyez votre demande à{" "}
            <a href="mailto:support@coach-os.eu" className="text-accent hover:underline">
              support@coach-os.eu
            </a>{" "}
            depuis l'adresse email associée à votre compte.
          </p>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default DeleteAccount;
